import { Box, Button, Checkbox, Divider, FormControlLabel, FormGroup, Modal,  Stack,  Tab,  Tabs,  Typography } from "@mui/material";
import { CategoryData, CountryData, TemplateData, TemplateModalTabTypes } from "../../../types";
import { useEffect, useState } from "react";
import { ScheduleBox } from "./ScheduleBox";
import { TargetingBox } from "./TargetingBox";
import { DemoGraphicsBox } from "./DemoGraphicsBox";
import { useAPI } from "../../../hooks/useAPI";
import { ConfirmDialog } from "../../../components/global/ConfirmDialog";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";

interface ScheduleModalProps {
  open: boolean;
  handleClose:() => void;
  handleSave:() => void;
  template: TemplateData;
  countries: CountryData[],
  categories: CategoryData[],
  clone?: boolean;
}

export const ScheduleModal = ({
  template, 
  countries, 
  categories,
  open,
  handleClose,
  handleSave,
  clone,
}: ScheduleModalProps) => {
  const [tab, setTab] = useState<TemplateModalTabTypes>("schedule");
  const [mTemplate, setMTemplate] = useState<TemplateData>(template);
  const { fetchData } = useAPI();
  const { isOpen, config, openDialog, closeDialog } = useConfirmDialog();

  useEffect(() => {
    setMTemplate({ ...template});
  }, [template]);

  const onSaveSchedule = async (template: TemplateData) => {
    const {errors, data} = await fetchData('/templates/save-schedule',  template, 'POST');
    if (errors) {
      // setError(errors);
    } else {
      handleSave();
    }
  }

  const onRemoveSchedule = async (template: TemplateData) => {
    const {errors, data} = await fetchData('/templates/remove-schedule',  { id: template.id }, 'POST');
    if (errors) {
      // setError(errors);
    } else {
      handleSave();
    }
  }

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ 
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: '750px',
        maxHeight: '90%',
        overflow: 'auto',
        bgcolor: 'background.paper',
        border: '1px solid #909894',
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius:'16px',
        p: 4,
       }}>
        <Typography id="modal-title" variant="h4" component="h2" fontWeight="600" fontFamily='korolev-condensed' mb={2}>
          Scheduling/Targeting
        </Typography>
        {/* <FormControlLabel
          style={{
            marginTop: '32px', 
            marginBottom: '8px', 
            color: '#4B5851', 
            fontStyle: 'italic',
            paddingLeft: '8px',
          }}
          label="Default (Will override any previously set default page.)"
          control={
            <Checkbox/>
          }
        /> */}
        <Divider />
        <Box mt={2}>
          <Tabs
            value={tab}
            onChange={(e: any, val: any) => setTab(val)}
            aria-label="wrapped label tabs example"
            sx={{ "& > .MuiTabs-fixed": { height: '30px'} }}
          >
            <Tab 
              value="schedule" 
              label="Schedule" 
              sx={{ 
                fontWeight: '600', 
                padding: '4px', 
                minWidth: '60px', 
                minHeight: '30px', 
                height: '30px', 
                marginRight: '10px',
                textTransform: 'capitalize',
                letterSpacing: '0.5px',
              }}
            />
            <Tab 
              value="demographics" 
              label="Demographics" 
              sx={{ 
                fontWeight: '600', 
                padding: '4px', 
                minWidth: '60px', 
                minHeight: '30px', 
                height: '30px' ,
                marginRight: '10px',
                textTransform: 'capitalize',
                letterSpacing: '0.5px',
              }}
            />
            <Tab 
              value="targeting" 
              label="Targeting" 
              sx={{ 
                fontWeight: '600', 
                padding: '4px', 
                minWidth: '60px', 
                minHeight: '30px', 
                height: '30px' ,
                textTransform: 'capitalize',
                letterSpacing: '0.5px',
              }}
            />
          </Tabs>
        </Box>
        <Box className="tab-content" style={{ padding: '8px 8px 32px 8px' }}>
          { tab === "schedule" && <ScheduleBox template={mTemplate} setTemplate={setMTemplate} /> }
          { tab === "demographics" && <DemoGraphicsBox template={mTemplate} setTemplate={setMTemplate} countries={countries} /> }
          { tab === "targeting" && <TargetingBox template={mTemplate} setTemplate={setMTemplate} categories={categories} /> }
        </Box>
        <FormGroup>
          <Stack direction='row' spacing={2}>
            <Button variant="contained" size="large" onClick={() => onSaveSchedule(mTemplate)}>
              Save Schedule
            </Button>
            {
              (template.client_id || template.schedule_id || template.demographic_id)  && (
                <Button variant="outlined" size="large" color="error" onClick={() => 
                  openDialog(
                    "Confirm Deletion",
                    `Are you sure you want to delete the schedule"?`,
                    () => onRemoveSchedule(mTemplate)
                  )
                }>
                  Remove Schedule
                </Button>
              )
            }
            <Button variant="text" size="large" onClick={handleClose}>
              Cancel
            </Button>
          </Stack>
        </FormGroup>
        <ConfirmDialog
          open={isOpen}
          title={config.title}
          description={config.description}
          onConfirm={config.onConfirm}
          onClose={closeDialog}
        />
      </Box>
    </Modal>
  )
}